import React, {useState, useRef, useEffect} from 'react'
import PropTypes from 'prop-types';
import PubSub from 'services/PubSub';
import Stars from '../Stars'
import Average from '../Average';
import Day from 'dayjs';
import SortBySelector from '../SortBySelector'
import ReviewsServices from 'services/Reviews';
import InfoMenssage from '../InfoMenssage';
import ShelfPaginator from 'components/ShelfPaginator';
import Loader from 'components/Loader';
import style from './style.scss'
import { features } from 'config';
import TagManagerService from 'services/TagManager'
import TitleWithBar from 'components/TitleWithBar';

const sortOptions = [
    { value: 'date-most-recent', label: 'Más reciente'},
    { value: 'date-oldest', label: 'Más antiguo'},
    { value: 'rating-descending', label: 'Mayor Rating'},
    { value: 'rating-ascending', label: 'Menor Rating'},
]

const perPage = 10;


const ReviewsContainer = (props) => {
    const {product} = props

    if(!product || !features.productReviews) return '';
    
    const [reviews, setReviews] = useState([]);
    const [range, setRage] = useState({})
    const [currentPage, setCurrentPage] = useState(1);
    const [orderParams, setOrder] = useState('');
    const [isLoading, setLoading] = useState(false);
    const reviewsRef = useRef(null);
    
    const defaultOption = sortOptions[0]

    useEffect(() => {
        _reviewsList();
    }, [])


    const _reviewsList = (params = '', currentPage) => {
        const to = currentPage * perPage || perPage;
        const from = perPage * (currentPage - 1) || 0;

        setLoading(true);
        ReviewsServices.listReviews(product.productId, from, to, params).then((result) => {
            if(result) {
                setLoading(false);
                setReviews(result.data)
                setRage(result.range);

                PubSub.dispatch('reviews_total_comments', result.range);
                if(result.data && result.data.length){
                    setTimeout(() => {
                        TagManagerService.interaction('Ver comentario', itemId, 'PDP -Reviews')
                    }, 3000)
                }
            }
        })
    }

    const sortComments = ({ value }) => {
        switch(value) {
            case 'rating-ascending':
                setOrder('order_by=Rating:asc')
                _reviewsList('&order_by=Rating:asc',currentPage);
                break
            case 'rating-descending':
                setOrder('order_by=Rating:desc')
                _reviewsList('&order_by=Rating:desc',currentPage);
                break
            case 'date-most-recent':
                setOrder('order_by=ReviewDateTime:desc')
                _reviewsList('&order_by=ReviewDateTime:desc',currentPage);
                break
            case 'date-oldest':
                setOrder('order_by=ReviewDateTime:asc')
                _reviewsList('&order_by=ReviewDateTime:asc',currentPage);
                break
        }
    }

    const date = (date) => {
        if(!date) return false;

        const arrDate = date.split(' ');
        const now = Day()
        const stdDate = Day(arrDate[0]);
        return now.diff(stdDate, 'day')
    }

    const setPage = (data) => {
        setCurrentPage(data);
        _reviewsList(orderParams, data)
    }
 
    const reviewsLength = reviews ? reviews.length : '';
    const totalPage = range?.total ? Math.ceil(range?.total / perPage) : 1;
    const itemId = product && product.items && product.items.length ? product.item.itemId : '';

    return (
        <div id="reviews-ratings" className='reviews' ref={reviewsRef}>
            <TitleWithBar title="Reseñas y Calificaciones" />
            {product && product.productId && <InfoMenssage reviewsLength={reviewsLength} productId={product.productId} itemId={itemId}/>}
            {product && product.productId && <Average comment={true} sectionReview={true} productId={product.productId} itemId={itemId}/>}
            {reviewsLength >= 1 && <div className='reviews-sorter'>
                <span className='reviews-quantity'>{reviewsLength} {reviewsLength > 1 ? 'calificaciones' : 'calificación'}</span>
                {reviewsLength >= 1 && <span className="reviews-sort-by">
                    <SortBySelector options={sortOptions} callback={sortComments} defaultOption={defaultOption} itemId={itemId} />
                </span>}
            </div>}
            <div className='reviews-container'>
                {isLoading && <div className="loader-reviews"><Loader /></div>}
                {!isLoading && reviews && reviews.map((item, i) => {
                    const dateDiff = date(item.reviewDateTime) === 0 ? ' Hoy ' : (' Hace  ' + date(item.reviewDateTime) + ' días');

                    return (
                        <div className='reviews-item' key={i}>
                            <div className='reviews-item-title'>
                                <Stars rating={item.rating} />
                                <span>{item.title}</span>
                            </div>
                            <div className='reviews-date'>
                                {dateDiff} {item.verifiedPurchaser ? <>| Compra verificada <i className='reviews-check-icon jumbo-icon-new-check' /></> : ''} 
                            </div>
                            <div className='reviews-comment'>
                                {item.reviewerName && <div className="reviews-reviewer-name">{item.reviewerName}</div>}
                                {item.text}
                            </div>
                        </div>
                    )
                })}
                {!isLoading && totalPage > 1 && <ShelfPaginator pages={totalPage} setPage={setPage} currentPage={Number(currentPage)}/>}
            </div>
        </div>
    )
}

ReviewsContainer.propTypes = {
    product: PropTypes.object.isRequired,
}

export default ReviewsContainer